
export interface GetMeetingListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetMeetingListPagingAndFilterResponseData
}

export interface GetMeetingListPagingAndFilterResponseData {
    items: GetMeetingListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetMeetingListPagingAndFilterResponseItem {
    meetingId: string
    companyId: string
    refNo: string
    selectedCompanyId: string
    selectedPersonAuthorizedPersonId: string
    selectedPersonAuthorizedPersonPhone: string
    selectedPersonAuthorizedPersonEmail: string
    note: string
    meetingTypeId: string
    meetingCompanyTypeId: string
    lostReason: string
    meetingRemindReasonId: string
    meetingRemindDate: string
    selectedCompanyName: string
    meetingTypeName: string
    meetingCompanyTypeName: string
    /** Görüşülen firmanın firma durumu (listede "Firma Durumu" kolonu). */
    initialCompanyTypeName: string
    meetingRemindReasonName: string
    fileArchives: GetMeetingListPagingAndFilterResponseFileArc[]
    isSelected: boolean
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
}

export interface GetMeetingListPagingAndFilterResponseFileArc {
    fileArchiveId: string
    entityId: string
    fileName: string
    url: string
    fileTypeId: string
    description: string
    fileTypeName: string
    createdDate: string
}

export const initialGetMeetingListPagingAndFilterResponseData: GetMeetingListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}